/* © CNES */
import { KeycloakProfile } from 'keycloak-js';

/**
 * Item model.
 */
export interface Item {
  value: string[] | string | undefined;
  isEditable: boolean;
}

/**
 * MyGeneralInformation model.
 */
export interface MyGeneralInformation {
  name: Item;
  firstName: Item;
  mail: Item;
  groups: Item;
}

/**
 * MyProfileInformation model
 */
export interface MyProfileInformation {
  organization: Item;
  job: Item;
  use: Item;
  nationality: Item;
  country: Item;
}

/**
 * MyAccessibilityInformation model
 */
export interface MyAccessibilityInformation {
  'download quota': Item;
  'processing quota': Item;
}

export interface MyKeycloakAttributes {
  country: string[];
  nationality: string[];
  activity: string[];
  use: string[];
  organization: string[];
  auth_source: string[];
  [key: string]: unknown;
}


/**
 * Override KeycloakProfile interface from keycloak-js
 */
export interface MyKeycloakProfile extends KeycloakProfile {
  attributes?: MyKeycloakAttributes;
}

export function toMyKeycloakProfile(profile: KeycloakProfile): MyKeycloakProfile | null {
  const attrs = profile.attributes;

  if (!attrs) return null;

  const requiredKeys: (keyof MyKeycloakAttributes)[] = [
    'country',
    'nationality',
    'activity',
    'use',
    'organization',
    'auth_source',
  ];

  const isValid = requiredKeys.every((key) => {
    const value = attrs[key];
    return Array.isArray(value) && value.every((item) => typeof item === 'string')
});

  if (!isValid) return null;

  return {
    ...profile,
    attributes: {
      country: attrs!.country as string[],
      nationality: attrs!.nationality as string[],
      activity: attrs!.activity as string[],
      use: attrs!.use as string[],
      organization: attrs!.organization as string[],
      auth_source: attrs!.auth_source as string[],
    },
  };
}
